import { FormBase } from 'core/components';

export default class ExportLabelsForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'carrierTypeServiceTypeId',
					label: 'FULFILLMENTORDER.EXPORTLABELSMODAL.CARRIERSERVICE',
					rules: 'required',
				},
			],
		};
	}
}
